import React, { useRef, useState, useEffect } from 'react';
import './HongAudioPlayer.scss';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import HongButton from '../comm/HongButton';

const HongAudioPlayer = ({
  audioSrc,
  autoPlay = false,
  onPlayCallback,
  onStopCallback,
  isShowStopBtn = true
}) => {
  const playerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const hasInteractedRef = useRef(false); // 사용자가 버튼 눌렀는지 여부

  // ✅ autoPlay가 true인 경우 재생 시도
  useEffect(() => {
    const audio = playerRef.current?.audio?.current;
    if (audio && autoPlay) {
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setIsPlaying(true);
            if (onPlayCallback) onPlayCallback();
          })
          .catch((err) => {
            console.warn('Autoplay blocked by browser:', err);
          });
      }
    }
  }, [audioSrc, autoPlay]);

  const handleToggle = () => {
    const audio = playerRef.current?.audio?.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      audio.currentTime = 0;
      if (onStopCallback) onStopCallback();
    } else {
      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            if (onPlayCallback) onPlayCallback();
          })
          .catch((err) => {
            console.warn('Playback failed:', err);
          });
      }
    }

    hasInteractedRef.current = true;
    setIsPlaying(!isPlaying);
  };

  if (!audioSrc) {
    return <p className="HongAudioPlayer">오디오 파일이 없습니다.</p>;
  }

  return (
    <div className="HongAudioPlayer">
      <div className="section-player">
        <AudioPlayer
          ref={playerRef}
          autoPlay={false} // 항상 false로 두고 수동 play()로 제어
          src={audioSrc}
          onPlay={() => {
            // 수동 조작 외의 자동 재생이 발생한 경우 감지
            if (!hasInteractedRef.current && !autoPlay) {
              const audio = playerRef.current?.audio?.current;
              if (audio) {
                audio.pause();
                audio.currentTime = 0;
              }
            } else {
              setIsPlaying(true);
            }
          }}
          onPause={() => setIsPlaying(false)}
          showJumpControls={false}
          customControlsSection={[]}
        />
      </div>

      {isShowStopBtn && (
        <button
          className="stop-button h-btn-white"
          onClick={handleToggle}
        >
          {isPlaying ? '중지' : '재생'}
        </button>
      )}
    </div>
  );
};

export default HongAudioPlayer;
